var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page rowBackgroundHomepage" }, [
    _c(
      "div",
      { staticClass: "showSmallScreenOnly" },
      [
        _vm.currentRole === "simple"
          ? _c(
              "f7-fab",
              {
                staticClass:
                  "leftfav button-fab bottomButton floatingButtonToolbarBlank color-inherit",
                attrs: {
                  disabled: _vm.$engine.rights.rightIs(
                    "business_members_add",
                    false
                  ),
                },
                on: { click: _vm.addUser },
              },
              [_c("f7-icon", { attrs: { f7: "add" } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentRole === "group"
          ? _c(
              "f7-fab",
              {
                staticClass:
                  "leftfav button-fab bottomButton floatingButtonToolbarBlank color-inherit",
                attrs: {
                  disabled: _vm.$engine.rights.rightIs("teams_add", false),
                },
                on: { click: _vm.addGroupMember },
              },
              [_c("f7-icon", { attrs: { f7: "add" } })],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "layoutTop" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "listPage" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "showLargeScreenOnly", attrs: { sm: "12" } },
                [
                  _vm.currentRole === "simple"
                    ? _c(
                        "div",
                        { staticClass: "firstButtonMarginLeft" },
                        [
                          _c(
                            "f7-button",
                            {
                              staticClass:
                                "milkyBlockBlack new-button-white firstBlock mt-0 mb-5",
                              attrs: { disabled: _vm.canAccessMember },
                              on: { click: _vm.addUser },
                            },
                            [
                              _c("f7-icon", { attrs: { f7: "add" } }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("businessMembers.add_member"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentRole === "group"
                    ? _c(
                        "div",
                        { staticClass: "firstButtonMarginLeft" },
                        [
                          _c(
                            "f7-button",
                            {
                              staticClass:
                                "milkyBlockBlack new-button-white firstBlock mt-0 mb-5",
                              attrs: { disabled: _vm.canAccessTeam },
                              on: { click: _vm.addGroupMember },
                            },
                            [
                              _c("f7-icon", { attrs: { f7: "add" } }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("businessMembers.add_team"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "div",
                  { staticClass: "contactButtonContainer filterTitle" },
                  [
                    _c(
                      "f7-grid",
                      { attrs: { "no-gutter": "" } },
                      [
                        _c(
                          "f7-col",
                          {
                            staticClass: "pilotageTabController",
                            attrs: { width: "50" },
                          },
                          [
                            _vm.currentRole === "simple"
                              ? _c(
                                  "f7-link",
                                  {
                                    staticClass: "pilotageLink",
                                    class: _vm.getColorActive,
                                    staticStyle: {
                                      "border-top-left-radius": "10px",
                                    },
                                    attrs: {
                                      "tab-link": ".membersTab1",
                                      active: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeCurrentRole("simple")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "businessMembers.members_label"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              : _c(
                                  "f7-link",
                                  {
                                    staticClass: "pilotageLink",
                                    class: _vm.getColorUnactive,
                                    staticStyle: {
                                      "border-top-left-radius": "10px",
                                    },
                                    attrs: {
                                      "tab-link": ".membersTab1",
                                      active: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeCurrentRole("simple")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "businessMembers.members_label"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "f7-col",
                          {
                            staticClass: "pilotageTabController",
                            attrs: {
                              width: "50",
                              disabled: _vm.$engine.rights.rightIs(
                                "teams_consult",
                                false
                              ),
                            },
                          },
                          [
                            _vm.currentRole === "group"
                              ? _c(
                                  "f7-link",
                                  {
                                    staticClass: "pilotageLink",
                                    class: _vm.getColorActive,
                                    staticStyle: {
                                      "border-top-right-radius": "10px",
                                    },
                                    attrs: { "tab-link": ".membersTab2" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeCurrentRole("group")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("businessMembers.teams_label")
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              : _c(
                                  "f7-link",
                                  {
                                    staticClass: "pilotageLink",
                                    class: _vm.getColorUnactive,
                                    staticStyle: {
                                      "border-top-right-radius": "10px",
                                    },
                                    style: [
                                      _vm.$engine.rights.rightIs(
                                        "teams_consult",
                                        false
                                      )
                                        ? { "background-color": "grey" }
                                        : {},
                                    ],
                                    attrs: { "tab-link": ".membersTab2" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeCurrentRole("group")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("businessMembers.teams_label")
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "f7-tabs",
                    { staticClass: "itemList" },
                    [
                      _c(
                        "f7-tab",
                        { staticClass: "membersTab1", attrs: { active: "" } },
                        [
                          _c("f7-searchbar", {
                            staticClass: "members-sb webdatalist",
                            attrs: {
                              id: "members-sb",
                              "search-list": "#members-list",
                              found: ".members-found",
                              "cancel-link": _vm.$t("common.cncl"),
                              placeholder: _vm.$t(
                                "businessMembers.srch_in_members"
                              ),
                            },
                            on: {
                              "searchbar:search": _vm.onSearch,
                              "searchbar:clear": _vm.onClear,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "layoutSubtitle" }),
                          _vm._v(" "),
                          _c(
                            "f7-list",
                            { staticClass: "searchbar-not-found" },
                            [
                              _c("f7-list-item", {
                                attrs: { title: _vm.$t("common.nthg_fnd") },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "f7-list",
                            {
                              staticClass: "members-found",
                              attrs: { id: "members-list" },
                            },
                            [
                              _c("cm-account-membersList-list", {
                                attrs: {
                                  userAccounts: _vm.userAccounts,
                                  filterBy: _vm.filterBy,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "f7-tab",
                        { staticClass: "membersTab2" },
                        [
                          _c("f7-searchbar", {
                            staticClass: "webdatalist",
                            attrs: {
                              "search-list": "#group-list",
                              "cancel-link": _vm.$t("common.cncl"),
                              placeholder: _vm.$t(
                                "businessMembers.srch_in_teams"
                              ),
                            },
                            on: {
                              "searchbar:search": _vm.onTeamSearch,
                              "searchbar:clear": _vm.onTeamSearchClear,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "layoutSubtitle" }),
                          _vm._v(" "),
                          _c(
                            "f7-list",
                            { staticClass: "searchbar-not-found" },
                            [
                              _c("f7-list-item", {
                                attrs: { title: _vm.$t("common.nthg_fnd") },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "f7-list",
                            {
                              staticClass: "group-found",
                              attrs: { id: "group-list" },
                            },
                            [
                              _c("cm-members-group-list", {
                                attrs: {
                                  membersGroup: _vm.membersGroup,
                                  filterBy: _vm.teamFilterBy,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "toolbarPageBottomBlank" }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }